// extracted by mini-css-extract-plugin
module.exports = {"terms_container":"TermsAndConditions_terms_container__Dq4_o","body_container":"TermsAndConditions_body_container__ZkcTk","title":"TermsAndConditions_title__1m9S9"};